import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Bounce } from 'react-reveal';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { Button,  Icon, Popup, Select} from 'semantic-ui-react';
import SKLT from '../../AssetsM/usedSlk';
import GConf from '../../AssetsM/generalConf';
import BreadCrumb from '../Assets/breadCrumb'
import { toast } from 'react-toastify';
import FrameForPrint from '../Assets/frameForPrint';
import usePrintFunction from '../Assets/Hooks/printFunction';
import { Input } from 'semantic-ui-react';
import TableGrid from '../Assets/tableGrid';
import { _ } from 'gridjs-react';

function TicketDePrixPage() {
    /*#########################[Const]##################################*/
    const navigate = useNavigate();
    const {FID} = useParams()
    const [articleL, setArticleL] = useState([])
    const [loading , setLoading] = useState(false)
    
    const [factureData, setFactData] = useState([])
    const [client, setClient] = useState('Passager')
    
    const [stockState , setStockState] = useState(false)
    const [toUpdatedList, setTUpList] = useState([])
    const [articleListe, setArticleListe] = useState([])
    let Offline = JSON.parse(localStorage.getItem(`${GConf.PID}_Offline`));
    
    /*#########################[UseEffect]##################################*/
    useEffect(() => {
        axios.post(`https://api.system.ansl.tn/API/familia-client/User/suivie-mg-retour`, {
            tag: 'userData.tag',
            clientId : '848565867',

          })
          .then(function (response) {
                
            console.log(response.data)
            let testTable = []
            response.data.map( (getData) => testTable.push([
            getData.A_Code,
            getData.Name,
            _(GetGenreFunc(getData.A_Code)),
            getData.Qte,
            _(<span className='text-primary text-decoration-underline' size='mini' style={{cursor: 'pointer'}} onClick={ (e) => navigate(`/S/ft/info/${getData.TID}`)}> { getData.TID}  </span>),
            _(<Button className='rounded-pill bg-danger text-white' size='mini' icon onClick={ (e) => navigate(`/S/ft/info/${getData.TID}`)}> <Icon  name='trash' /></Button>)
            ],))
                setArticleL(testTable)
                setLoading(true)
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de Charger la facture de son source   </div></>, GConf.TostInternetGonf)   
              const FactureTarged = Offline.facture.find((facture) => facture.F_ID == FID);
              setLoading(true)
              
            }
          });

           
    }, [articleListe])
    
    useEffect(() => {
          axios.post(`${GConf.ApiLink}/stock`, {
            PID : GConf.PID,
          })
          .then(function (response) {
            setArticleListe(response.data)
          })
    }, [])

    /*#########################[Function]##################################*/
    const PrintFunction = (frameId) =>{ usePrintFunction(frameId)}
    const RetouAuStock = () =>{
        axios.post(`${GConf.ApiLink}/stock/be`, {
            PID : GConf.PID,
            artList: articleL,
          })
          .then(function (response) {      
            if(response.data.affectedRows) {
                // axios.post(`${GConf.ApiLink}/facture/us`, { PID : GConf.PID,  fid: FID })
                toast.success("Stock Modifier !", GConf.TostSuucessGonf)
                setStockState(true)
                setFactData({ ...factureData, SDF: 'true'})
            }
            else{
                toast.error('Erreur Indéfine ', GConf.TostSuucessGonf)
            }
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Operation Annuleé  </div></>, GConf.TostInternetGonf)   
            }
          });

    }
    const DeleteListe =  () =>{
        axios.post(`${GConf.ApiLink}/tools/ticket/prix/supprimer`, {
            PID : GConf.PID,
          })
          .then(function (response) {
                toast.success('Liste Vide', GConf.TostSuucessCaisseGonf)
                setLoading(true)
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5>     </div></>, GConf.TostInternetGonf)   
              setLoading(true)
              
            }
          });
    }
    const AjouterAuxListe =  () =>{}
    const GetGenreFunc = (Code) => {
        let result = articleListe.find((data) => data.A_Code == Code)
        if (result) {
            return result.Genre
        } else {
            return null
        }
    }
    /*#########################[Card]##################################*/
    const AjouterCard = () =>{
        return(<>
                <div className='card card-body shadow-sm mb-2'>
                    <h5 className='mb-1'>Liste des prix: </h5>
                    <Select placeholder='Selectionnez' options={[]}     className='w-100 shadow-sm rounded mb-3'  />
                    <Button  className='rounded-pill btn-imprimer'  fluid onClick={ (e) => AjouterAuxListe()}><Icon name='print' /> Ajouter Aux Liste </Button>
                </div>
        </>)
    }
    const BtnsCard = () =>{
        return(<>
                <div className='card card-body shadow-sm mb-2'>
                    <h5>Controle</h5>
                    <div className='row mb-2'>
                    
                    <div className='col-3 mb-2'>
                        <Button  className='rounded-pill btn-imprimer'  fluid onClick={(e) => PrintFunction('printTicketPrix')}><Icon name='print' /> Normale</Button>
                    </div>
                    <div className='col-3 mb-2'>
                        <Button  className='rounded-pill btn-imprimer'  fluid onClick={(e) => PrintFunction('printTicketPrixMoyenne')}><Icon name='print' /> Moyenne</Button>
                    </div>
                    <div className='col-3'>
                        <Button  className='rounded-pill btn-imprimer'  fluid onClick={(e) => PrintFunction('printTicketPrixLarge')}><Icon name='print' /> Large</Button>
                    </div>
                    <div className='col-3'>
                            {/* <Button  className='rounded-pill bg-danger text-white' onClick={() => DeleteListe()} fluid><Icon name='trash' /> Vider </Button> */}
                        </div>
                    </div>
                     

                </div>
        </>)
    }

    return ( <>
            <div className='container'>
                <h5>Retour magazin  </h5> 
                <br />
                <div className="row">
                    <div className="col-12 ">
                            <Bounce bottom>
                                <div className="sticky-top" style={{top:'70px'}}>
                                    {/* <AjouterCard /> */}
                                    <BtnsCard /> 
                                </div>
                            </Bounce>
                    </div>
                    <div className="col-12">
                        <div className="row mb-3">
                                
                                {loading ?  
                                <>
                                <TableGrid tableData={articleL} columns={['date','artile','Genre','qte','voir','Supp']} /> 
                                </>
                                : SKLT.FactureList }                        
                                
                        </div>
                    </div>
                    
                </div>
                <FrameForPrint frameId='printTicketPrix' src={`/Pr/Tools/print/retour-mg`} />                
                {/* <FrameForPrint frameId='printTicketPrixLarge' src={`/Pr/Tools/print/prix/large`} />                
                <FrameForPrint frameId='printTicketPrixMoyenne' src={`/Pr/Tools/print/prix/moyenne`} />                 */}
            </div>
    </> );
}

export default TicketDePrixPage;